module.exports = __webpack_public_path__ + "img/4.9908b092.jpeg";